import { YOO_FINDS_H5_CDN_URL } from "@/common/domains";

const baseUrl = `${YOO_FINDS_H5_CDN_URL}/h5/images`;

export const AVATAR_FALLBACK_48 = `${baseUrl}/avatar-fallback-48.png`;

export const AVATAR_FAILED_48 = `${baseUrl}/avatar-failed-48.png`;

export const PRODUCT_IMAGE_PLACEHOLDER = `${baseUrl}/image-placeholder.png`;

export const VIDEO_PLACEHOLDER = `${baseUrl}/video-placeholder.png`;
